import React, { useState } from "react";

/**
 * Props:
 * - text: string
 * - alignment: 'left' | 'right'
 * - isBot?: boolean         // if true, show hover thumbs
 * - feedback?: 'up'|'down'  // selected reaction to render inline
 * - onLike?: () => void
 * - onDislike?: () => void
 */
export default function ChatBubble({
  text,
  alignment = "left",
  isBot = false,
  feedback,
  onLike,
  onDislike,
}) {
  const [hover, setHover] = useState(false);

  const bubbleStyle = {
    maxWidth: "72%",
    padding: "12px 14px",
    borderRadius: 14,
    lineHeight: "1.45",
    fontSize: 14,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    background: alignment === "right" ? "#1559EA" : "#ffffff",
    color: alignment === "right" ? "#ffffff" : "#111827",
    border: alignment === "right" ? "none" : "1px solid #E5E7EB",
    boxShadow: alignment === "right" ? "none" : "0 2px 10px rgba(0,0,0,0.04)",
  };

  const wrapStyle = {
    display: "flex",
    justifyContent: alignment === "right" ? "flex-end" : "flex-start",
    position: "relative",
  };

  const actionsWrapStyle = {
    position: "absolute",
    right: alignment === "right" ? "auto" : -6,
    left: alignment === "right" ? -6 : "auto",
    top: -10,
    display: hover && isBot ? "flex" : "none",
    gap: 6,
    background: "rgba(255,255,255,0.9)",
    border: "1px solid #E5E7EB",
    borderRadius: 999,
    padding: "4px 6px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    zIndex: 2,
  };

  const iconBtn = {
    border: "none",
    background: "transparent",
    cursor: "pointer",
    fontSize: 14,
    lineHeight: 1,
    padding: "2px 4px",
  };

  // Inline reaction (at end of message)
  const reaction =
    feedback === "up" ? " 👍" : feedback === "down" ? " 👎" : "";

  return (
    <div
      style={wrapStyle}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {/* Hover-only thumbs for bot messages */}
      <div style={actionsWrapStyle} aria-hidden={!hover}>
        <button
          type="button"
          style={iconBtn}
          title="Thumbs up"
          onClick={onLike}
          aria-label="Thumbs up"
        >
          👍
        </button>
        <button
          type="button"
          style={iconBtn}
          title="Thumbs down"
          onClick={onDislike}
          aria-label="Thumbs down"
        >
          👎
        </button>
      </div>

      <div style={bubbleStyle}>
        {text}
        {/* show selected reaction inline at end */}
        {reaction && <span style={{ opacity: 0.9 }}>{reaction}</span>}
      </div>
    </div>
  );
}
